import {forwardRef, useState} from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import {
    Box,
    FormControl,
    FormHelperText, InputBase,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import React from "react";
import MDTypography from "../MDTypography";
import pxToRem from "../../Asset/theme/functions/pxToRem";
import MDInput from "../MDInput";
import {styled} from "@mui/material/styles";

// Custom styles for MDInput
const BootstrapInput = styled(InputBase)(({theme}) => ({
    'label + &': {
        background: "white!important"
    },
    '& .MuiInputBase-input': {
        borderRadius: "5px",
        height: "28px",
        fontSize: "20px",
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        borderColor: '#477B04',
        fontFamily: [
            'naznin',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: "12px",

            // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}));

const MDSelect = ({
                      name,
                      onChange,
                      label,
                      disabled,
                      value,
                      error,
                      helperText,
                      children,
    w,
                      blg = false,
                      id
                  }) => {
    const handleChange = (event) => {
        if (event.target.value === "none") {
            return onChange(null);
        }
        return onChange(event.target.value);
    };

    return (
        <FormControl
            sx={{width: w}}
            focused
        >
            <InputLabel sx={{
                fontSize: 22,
                background: "white",
                borderRadius: "10px",
                color: "black"
            }}>{label}</InputLabel>
            <Select
                name={name}
                disabled={disabled ?? false}
                onChange={handleChange}
                native
                value={value}
                id={id}
                label={label}
                input={<BootstrapInput/>}
                // sx={{width: {xs: "60%", md: "60%", sm: "60%",}}}
                width={"100%"}
                variant={"filled"}>
                <option value={"none"}>بدون انتخاب</option>
                {children}
            </Select>
            {error && (
                <MDTypography
                    color={"error"}
                    fontSize={pxToRem(12)}
                    sx={{margin: "0 12px"}}
                >
                    {helperText}
                </MDTypography>
            )}
        </FormControl>
    );
};

export default MDSelect;
